// Builds a WhatsApp share URL that recommends every doctor in a specialty
// group at once. Lands on the patient's friend's phone as a friendly,
// scannable message with one DocSite profile link per doctor.

// We hard-code docsite.care so the link the friend opens is always the
// production marketing surface (preview deploys would 404 on signed-out
// patient sessions).
const PUBLIC_HOST = 'https://docsite.care';

function profileUrl(slug) {
  return slug ? `${PUBLIC_HOST}/dr/${slug}` : PUBLIC_HOST;
}

function clinicSummary(c) {
  // Friendly one-line clinic descriptor — prefers clinic name, then suburb.
  const bits = [];
  if (c.clinic_name) bits.push(c.clinic_name);
  const locality = c.city || c.address;
  if (locality) bits.push(locality.split(',')[0].trim());
  return bits.filter(Boolean).join(', ');
}

// `doctors` is the array from a specialty group; `specialtyLabel` is the
// human-readable group title (e.g. "ENT — Ear, Nose & Throat").
// `slugAccessor` lets the caller pick the right field — MyClinicsPage uses
// `doctor_slug`, MyClinicsPreviewPage's sample data uses `slug`.
export function buildRecommendUrl({ specialtyLabel, doctors, slugAccessor = (c) => c.doctor_slug || c.slug }) {
  const lines = (doctors || [])
    .map((c) => {
      const where = clinicSummary(c);
      const url = profileUrl(slugAccessor(c));
      return where
        ? `• ${c.doctor_name} — ${where}\n  ${url}`
        : `• ${c.doctor_name}\n  ${url}`;
    });

  const intro = doctors && doctors.length > 1
    ? `🌟 You should check out these ${specialtyLabel} specialists I trust on DocSite:`
    : `🌟 You should check out this ${specialtyLabel} specialist I trust on DocSite:`;

  const message = `${intro}\n\n${lines.join('\n\n')}\n\n— Recommended via DocSite (docsite.care)`;
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}

export default buildRecommendUrl;
